// import { createList } from 'shared/pages'
export default [
  {
    path: '',
    name: 'weekplanModule_list',
    component: () => import('./List.vue'),
  },
]
